import { kebabCase } from '@fergdigitalcommerce/fergy-utilities';
import { type FunctionComponent } from 'react';
import type {
	ContentComponent,
	ContentRenderer,
	ListContentOf,
	ObjectContent,
	RichTextContent,
	TextContent
} from '../../../types/construct.types';
import { scrollToElement } from '../../../utils/dom/dom.utils';
import { TextButton } from '../../buttons';

const FAQ_ID = 'frequently-asked-questions';
export interface FrequentlyAskedQuestionsContent extends ObjectContent {
	fields: {
		faqList: ListContentOf<FrequentlyAskedQuestionsEntryContent>;
	};
}

export interface FrequentlyAskedQuestionsEntryContent extends ObjectContent {
	fields: {
		question: TextContent;
		answer: RichTextContent;
	};
}

export const generateLinkId = (contentTitle: TextContent): string => {
	if (!contentTitle) {
		return '';
	}

	return kebabCase(contentTitle.replace(/[^\sa-z0-9]/gi, ''));
};

export const FrequentlyAskedQuestionsComponent: ContentComponent<FrequentlyAskedQuestionsContent> = ({ content, renderer }) => (
	<div id={FAQ_ID}>
		<h3 className="mt4">Frequently Asked Questions</h3>
		<ol className="lh-copy">
			{content.fields.faqList.items.map((item, index) => (
				<li key={index}>
					<TextButton onClick={() => scrollToElement(`${generateLinkId(item.fields.question)}`)}>
						{item.fields.question}
					</TextButton>
				</li>
			))}
		</ol>
		{content.fields.faqList.items.map((item, index) => (
			<FrequentlyAskedQuestion key={index} item={item} displayNumber={index + 1} renderer={renderer} />
		))}
	</div>
);

type FrequentlyAskedQuestionProps = {
	item: FrequentlyAskedQuestionsEntryContent;
	displayNumber: number;
	renderer: ContentRenderer<FrequentlyAskedQuestionsContent>;
};

const FrequentlyAskedQuestion: FunctionComponent<FrequentlyAskedQuestionProps> = ({ item, displayNumber, renderer }) => (
	<div className="mt4" id={generateLinkId(item.fields.question)}>
		<div>
			<strong>
				{displayNumber}. {item.fields.question}
			</strong>
		</div>
		<div className="mt3">{renderer.render(item.fields.answer)}</div>
		<div className="mt3">
			<TextButton onClick={() => scrollToElement(FAQ_ID)}>Back to top</TextButton>
		</div>
	</div>
);
